import {defineMessages} from 'react-intl';

const messages = defineMessages({
	viewNotValid: {
		id: 'resetPassword.viewNotValid',
		defaultMessage: 'This view is accessible only by clicking on a reset password link sent via email',
	},
});

export default messages;